/**
 * 「当前主题 + 推荐主题」这一排能有几列。
 *
 * 不写断点，按"一张卡至少要多宽"反算：同一套控制台，1440 的笔记本上是 4 列，
 * 27 寸上是 6 列。断点只能猜两三档，猜不准的地方不是右边空一大块，就是把卡片
 * 挤成一条 —— 而这块本来就想让宽屏多露几套推荐。
 */
export const PICK_CARD_MIN = 240;

/** 卡间距，和 `.theme-grid` 的 gap 保持一致（算列数时要一起算进去） */
export const PICK_GAP = 12;

/** 一排最多几张。再多就变成"在缩略图里挑"，而这正是这一屏要避免的事 */
export const PICK_COLUMNS_MAX = 7;

/** 量不到宽度时（首帧、容器隐藏）先按四列画，和加自适应之前一模一样 */
export const PICK_COLUMNS_FALLBACK = 4;

export function pickColumns(width: number, max: number = PICK_COLUMNS_MAX): number {
  if (!Number.isFinite(width) || width <= 0) return PICK_COLUMNS_FALLBACK;
  // n 张卡加 n-1 个间隔放得下的最大 n
  const fit = Math.floor((width + PICK_GAP) / (PICK_CARD_MIN + PICK_GAP));
  return Math.min(max, Math.max(1, fit));
}
